"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ignoreMiddleware;
function ignoreMiddleware(network) {
  const FILTERED = new Set(['PRIVMSG', 'NOTICE', 'TAGMSG']);
  return function middleware(client, rawEvents /* , parsedEvents */) {
    rawEvents.use((command, message, rawLine, c, next) => {
      if (!message || !message.nick || !FILTERED.has(command)) {
        next();
        return;
      }
      const lower = message.nick.toLowerCase();
      const ignored = network.ignored_list.some(n => n.toLowerCase() === lower);
      if (!ignored) {
        next();
      }
    });
  };
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IgnoreMiddleware"]
window._kiwi_exports.libs.IgnoreMiddleware = exports.default ? exports.default : exports;
